import { createSlice } from "@reduxjs/toolkit";
import { STATUS } from "../constant";

const initialState = {
	login: {
		status: STATUS.IDLE,
		data: null,
		token: null,
	},
	logout: {
		status: STATUS.IDLE,
		data: null,
		token: null,
	},
	preForgotPassword: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	forgotPassword: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	updatePassword: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	register: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	postRegister: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	avatar: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	uploadAvatar: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	phoneNumber: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	resendOTP: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	Verification: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	user: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	redirect: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	subscirption: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	deleteAccount: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
	verifyPassword: {
		status: STATUS.IDLE,
		data: null,
		error: null,
	},
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		preForgotPassword(state, _action) {
			state.preForgotPassword.status = STATUS.REQUEST;
			state.preForgotPassword.data = null;
			state.preForgotPassword.error = null;
		},
		preForgotPasswordSuccess(state, action) {
			state.preForgotPassword.data = action.payload.data;
			state.preForgotPassword.error = null;
			state.preForgotPassword.status = STATUS.SUCCESS;
		},
		preForgotPasswordFailure(state, action) {
			state.preForgotPassword.data = null;
			state.preForgotPassword.error = action.payload.data;
			state.preForgotPassword.status = STATUS.FAILED;
		},
		forgotPassword(state, _action) {
			state.forgotPassword.status = STATUS.REQUEST;
			state.forgotPassword.data = null;
			state.forgotPassword.error = null;
		},
		forgotPasswordSuccess(state, action) {
			state.forgotPassword.data = action.payload.data;
			state.forgotPassword.error = null;
			state.forgotPassword.status = STATUS.SUCCESS;
		},
		forgotPasswordFailure(state, action) {
			state.forgotPassword.data = null;
			state.forgotPassword.error = action.payload.data;
			state.forgotPassword.status = STATUS.FAILED;
		},
		updatePassword(state, _action) {
			state.updatePassword.status = STATUS.REQUEST;
			state.updatePassword.data = null;
			state.updatePassword.error = null;
		},
		updatePasswordSuccess(state, action) {
			state.updatePassword.data = action.payload.data;
			state.updatePassword.error = null;
			state.updatePassword.status = STATUS.SUCCESS;
		},
		updatePasswordFailure(state, action) {
			state.updatePassword.data = null;
			state.updatePassword.error = action.payload.data;
			state.updatePassword.status = STATUS.FAILED;
		},
		register(state, _action) {
			state.register.status = STATUS.REQUEST;
			state.register.data = null;
			state.register.error = null;
		},
		registerSuccess(state, action) {
			state.register.status = STATUS.SUCCESS;
			state.register.data = action.payload.data;
			state.register.error = null;
		},
		registerFailure(state, action) {
			state.register.status = STATUS.FAILED;
			state.register.data = null;
			state.register.error = action.payload;
		},
		postRegister(state, _action) {
			state.postRegister.status = STATUS.REQUEST;
			state.postRegister.data = null;
			state.postRegister.error = null;
		},
		postRegisterSuccess(state, action) {
			state.postRegister.status = STATUS.SUCCESS;
			state.postRegister.data = action.payload.data;
			state.postRegister.error = null;
		},
		postRegisterFailure(state, action) {
			state.postRegister.status = STATUS.FAILED;
			state.postRegister.data = null;
			state.postRegister.error = action.payload.data;
		},
		preSignAvatar(state, _action) {
			state.avatar.status = STATUS.REQUEST;
			state.avatar.data = null;
			state.avatar.error = null;
		},
		preSignAvatarSuccess(state, action) {
			state.avatar.status = STATUS.SUCCESS;
			state.avatar.data = action.payload.data;
			state.avatar.error = null;
		},
		preSignAvatarFailure(state, action) {
			state.avatar.status = STATUS.SUCCESS;
			state.avatar.data = null;
			state.avatar.error = action.payload.data;
		},
		phoneNumber(state, _action) {
			state.phoneNumber.status = STATUS.REQUEST;
			state.phoneNumber.data = null;
			state.phoneNumber.error = null;
		},
		phoneNumberSuccess(state, action) {
			state.phoneNumber.status = STATUS.SUCCESS;
			state.phoneNumber.data = action.payload.data;
			state.phoneNumber.error = null;
		},
		phoneNumberFailure(state, action) {
			state.phoneNumber.status = STATUS.FAILED;
			state.phoneNumber.data = null;
			state.phoneNumber.error = action.payload.data;
		},
		verification(state, _action) {
			state.Verification.status = STATUS.REQUEST;
			state.Verification.data = null;
			state.Verification.error = null;
		},
		verificationSuccess(state, action) {
			state.Verification.status = STATUS.SUCCESS;
			state.Verification.data = action.payload.data;
			state.Verification.error = null;
		},
		verificationFailure(state, action) {
			state.Verification.status = STATUS.FAILED;
			state.Verification.data = null;
			state.Verification.error = action.payload.data;
		},
		getUserData(state, _action) {
			state.user.status = STATUS.REQUEST;
			state.user.data = null;
			state.user.error = null;
		},
		getUserDataSuccess(state, action) {
			state.user.status = STATUS.SUCCESS;
			state.user.data = action.payload.data;
			state.user.error = null;
		},
		getUserDataFailure(state, action) {
			state.user.status = STATUS.FAILED;
			state.user.data = null;
			state.user.error = action.payload.error;
		},
		redirectUser(state, _action) {
			state.redirect.status = STATUS.REQUEST;
			state.redirect.data = null;
			state.redirect.error = null;
		},
		redirectUserSuccess(state, action) {
			state.redirect.status = STATUS.SUCCESS;
			state.redirect.data = action.payload.data;
			state.redirect.error = null;
		},
		redirectUserFailure(state, action) {
			state.redirect.status = STATUS.FAILED;
			state.redirect.data = null;
			state.redirect.error = action.payload.error;
		},
		subcsrition(state, _action) {
			state.subscirption.status = STATUS.REQUEST;
			state.subscirption.data = null;
			state.subscirption.error = null;
		},
		subcsritionSuccess(state, action) {
			state.subscirption.status = STATUS.SUCCESS;
			state.subscirption.data = action.payload.data;
			state.subscirption.error = null;
		},
		subcsritionFailure(state, action) {
			state.subscirption.status = STATUS.FAILED;
			state.subscirption.data = null;
			state.subscirption.error = action.payload.error;
		},
		deleteAccount(state, _action) {
			state.deleteAccount.status = STATUS.REQUEST;
			state.deleteAccount.data = null;
			state.deleteAccount.error = null;
		},
		deleteAccountSuccess(state, action) {
			state.deleteAccount.status = STATUS.SUCCESS;
			state.deleteAccount.data = action.payload.data;
			state.deleteAccount.error = null;
		},
		deleteAccountFailure(state, action) {
			state.deleteAccount.status = STATUS.FAILED;
			state.deleteAccount.data = null;
			state.deleteAccount.error = action.payload.error;
		},
		resendOTP(state, _action) {
			state.resendOTP.status = STATUS.REQUEST;
			state.resendOTP.data = null;
			state.resendOTP.error = null;
		},
		resendOTPSuccess(state, action) {
			state.resendOTP.status = STATUS.SUCCESS;
			state.resendOTP.data = action.payload.data;
			state.resendOTP.error = null;
		},
		resendOTPFailure(state, action) {
			state.resendOTP.status = STATUS.FAILED;
			state.resendOTP.data = null;
			state.resendOTP.error = action.payload.error;
		},
		verifyPassword(state, _action) {
			state.verifyPassword.status = STATUS.REQUEST;
			state.verifyPassword.data = null;
			state.verifyPassword.error = null;
		},
		verifyPasswordSuccess(state, action) {
			state.verifyPassword.status = STATUS.SUCCESS;
			state.verifyPassword.data = action.payload.data;
			state.verifyPassword.error = null;
		},
		verifyPasswordFailure(state, action) {
			state.verifyPassword.status = STATUS.FAILED;
			state.verifyPassword.data = null;
			state.verifyPassword.error = action.payload.error;
		},
	},
});

export const {
	preForgotPassword,
	preForgotPasswordSuccess,
	preForgotPasswordFailure,
	forgotPassword,
	forgotPasswordSuccess,
	forgotPasswordFailure,
	updatePassword,
	updatePasswordSuccess,
	updatePasswordFailure,
	register,
	registerSuccess,
	registerFailure,
	postRegister,
	postRegisterSuccess,
	postRegisterFailure,
	preSignAvatar,
	preSignAvatarSuccess,
	preSignAvatarFailure,
	phoneNumber,
	phoneNumberSuccess,
	phoneNumberFailure,
	verification,
	verificationSuccess,
	verificationFailure,
	getUserData,
	getUserDataSuccess,
	getUserDataFailure,
	redirectUser,
	redirectUserSuccess,
	redirectUserFailure,
	subcsrition,
	subcsritionSuccess,
	subcsritionFailure,
	deleteAccount,
	deleteAccountSuccess,
	deleteAccountFailure,
	resendOTP,
	resendOTPSuccess,
	resendOTPFailure,
	verifyPassword,
	verifyPasswordSuccess,
	verifyPasswordFailure,
} = authSlice.actions;

export default authSlice.reducer;
